import { useAuth } from '../lib/auth';

const PHASES = [
  {
    id: 'ricerca',
    label: 'Ricerca',
    sub: 'Trova l\'asta giusta',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
  },
  {
    id: 'sopralluogo',
    label: 'Sopralluogo',
    sub: 'Controlla l\'immobile',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  },
  {
    id: 'asta',
    label: 'Asta',
    sub: 'Partecipa e rilancia',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m14 17 6-6-7-1.5L7 16l7 1z" />
        <path d="m14 17-7-1L2 22l8-3z" />
        <line x1="14" y1="11" x2="20" y2="5" />
      </svg>
    ),
  },
  {
    id: 'chiavi',
    label: 'Chiavi',
    sub: 'Decreto e consegna',
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="7.5" cy="15.5" r="5.5" />
        <path d="m21 2-9.6 9.6" />
        <path d="m15.5 7.5 3 3L22 7l-3-3" />
      </svg>
    ),
  },
];

// Current active phase — placeholder. Sarà collegato a un campo reale (es. ultimo
// stato della trattativa attiva del cliente B2C) in un secondo step.
const ACTIVE_INDEX = 0;

export default function B2cPhases() {
  const { user } = useAuth();
  if (!user?.is_b2c) return null;

  const progressPct = ((ACTIVE_INDEX) / (PHASES.length - 1)) * 100;

  return (
    <div className="b2c-phases">
      <div className="b2c-phases__inner">
        <div className="b2c-phases__header">
          <div className="b2c-phases__title">Il tuo percorso</div>
          <div className="b2c-phases__hint">
            Fase {ACTIVE_INDEX + 1} di {PHASES.length} ·{' '}
            <span className="b2c-phases__hint-strong">{PHASES[ACTIVE_INDEX].label}</span>
          </div>
        </div>

        <div className="b2c-phases__track">
          <div className="b2c-phases__rail" />
          <div className="b2c-phases__rail b2c-phases__rail--filled"
               style={{ width: `${progressPct}%` }} />

          <ol className="b2c-phases__steps">
            {PHASES.map((phase, i) => {
              const state =
                i < ACTIVE_INDEX ? 'done' : i === ACTIVE_INDEX ? 'current' : 'locked';
              return (
                <li key={phase.id} className="b2c-phase" data-state={state}>
                  <div className="b2c-phase__bullet">
                    {state === 'done' ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="3"
                           strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    ) : state === 'locked' ? (
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                           stroke="currentColor" strokeWidth="2.2"
                           strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    ) : (
                      phase.icon
                    )}
                  </div>
                  <div className="b2c-phase__meta">
                    <span className="b2c-phase__num">0{i + 1}</span>
                    <span className="b2c-phase__label">{phase.label}</span>
                    <span className="b2c-phase__sub">{phase.sub}</span>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  );
}
